import { Fragment, useEffect, useState } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { LinkButtons } from '../FieldComponets/LinkButtons';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import React from 'react';
import { getDate } from '../../utils/Helper';
import { EmailtemplateGetAction } from '../../Redux/Action/EmailTemplateAction';


function EmailManagementList() {

  const dispatch = useDispatch<any>();

  const EmailTemplateGet = useSelector((state: any) => state.EmailTemplateGetState);



  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);

  const [sorting, setSorting] = useState<any>(['ASC']);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState('');
  const [rowCount, setRowCount] = useState(0);





  // Table Coulmns
  const columns: any = [
    {
      accessorKey: 'id',
      header: 'S.No',
      filterVariant: 'id',
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      size: 50,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'title',
      header: 'Title',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'slug',
      header: 'Slug',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: 'Action',
      size: 50,
      accessorFn: (row: { id: any; }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`email-template/edit`}
                pageID={row?.id}
                showEdit={true}
                showView={false}
                showDelete={false}
              />
            </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters,

        );

        await dispatch(EmailtemplateGetAction(query));

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);
  useEffect(() => {
    setData(EmailTemplateGet?.data?.data?.rows);
    setRowCount(EmailTemplateGet?.data?.data?.count);
  }, [EmailTemplateGet?.data]);



  return (
    <Fragment>
      {(loading || EmailTemplateGet?.loading) ? <Spinner /> : ""}


      <PageLayout
        title="Email Template"
        breadcrumbs={{
          secLast: { 'link': '/email-template', 'name': 'Email Management' },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >



        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            // enableStickyHeader={true}
            // enableStickyFooter={true}
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                  color: 'error',
                  children: 'Error loading data',
                }
                : undefined
            }
            muiSearchTextFieldProps={{
              placeholder: 'Search from name',

            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              // dispatch,
              // HorseShowGetAction, 
              // setPagination, 
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
              // pagination, 
              // sorting, 
              // columnFilters,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              // globalFilter,
              // isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }

      </PageLayout>
    </Fragment>
  )
}


export default EmailManagementList